import React, { Component } from 'react'
import { browserHistory } 	from "react-router";
import { Link } 				from "react-router";
import { PrimaryButton, InvertedPrimaryButton } from '../Ui'

class SubscribeChoice extends Component {
	constructor(props) {
		super(props);

		this.state = {
			fields: {}
		}

	}

	render() {

		return 	(
			<div className="subscribe-choice__wrapper">
				<div className="subscribe-choice__container">
					<div className="subscribe-choice__column">
						<h1 className="subscribe-choice__header">Vous n&#39;avez pas encore d&#39;identifiant</h1>
						<div className="subscribe-choice__content">
							<p className="subscribe-choice__content-text">Vous êtes client chez Legallais mais vous n&#39;êtes pas encore inscrit sur le site.</p>
							<div className="subscribe-choice__action">
								<Link to={"/subscribe/user-sign"}>
									<InvertedPrimaryButton>S&#39;inscrire sur le site</InvertedPrimaryButton>
								</Link>
							</div>
						</div>
					</div>
					<div className="subscribe-choice__column">
						<h1 className="subscribe-choice__header">Nouveau client Legallais</h1>
						<div className="subscribe-choice__content">
							<p className="subscribe-choice__content-text">Ouvrez votre compte en quelques minutes, et profitez des offres de capitaine Clés.</p>
							<div className="subscribe-choice__action">
								<Link className="link" to={"/subscribe/new-account"}>
									<PrimaryButton>
										Créer un compte
									</PrimaryButton>
								</Link>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}

}

export default SubscribeChoice



// WEBPACK FOOTER //
// ./src/js/subscribe/SubscribeChoice.js